export type Route = string;

type Listener = (route: Route, params: URLSearchParams) => void;

const listeners = new Set<Listener>();

export function currentRoute(): { path: string; params: URLSearchParams } {
  const hash = location.hash.replace(/^#/, '') || '/today';
  const [rawPath = '', qs = ''] = hash.split('?');
  // Hash like `#?foo=bar` produces an empty path; default to /today.
  const path = rawPath || '/today';
  return { path, params: new URLSearchParams(qs) };
}

export function navigate(path: string, params?: Record<string, string>) {
  const qs = params && Object.keys(params).length ? '?' + new URLSearchParams(params).toString() : '';
  const next = '#' + path + qs;
  if (location.hash === next || (location.hash === '' && next === '#/today')) {
    // Same-hash navigate: hashchange won't fire, so the screen never re-renders.
    // Fire it ourselves so "Try another rescue" / "Keep waiting" / any other
    // button that targets the current route does something visible.
    window.dispatchEvent(new HashChangeEvent('hashchange', { oldURL: location.href, newURL: location.href }));
    return;
  }
  location.hash = next;
}

export function onRouteChange(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

window.addEventListener('hashchange', () => {
  const { path, params } = currentRoute();
  for (const l of listeners) l(path, params);
});

export function startRouter() {
  if (!location.hash) location.hash = '#/today';
}
